export const statusOptions = [
  { id: "0", name: "Pending" },
  { id: "1", name: "Checked In" },
];
